import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';

export function AgreementWithoutServicePlanModalContentVwView(): ReactElement {
  return <Text appearance={TokenTextAppearance.copy200}>The price is an estimate and is non-binding, prices may differ.</Text>;
}
